// RESET
export const RESET = 'RESET';

// INITIAL_LOADING
export const INITIAL_LOADING_PENDING = 'INITIAL_LOADING_PENDING';
export const INITIAL_LOADING_FULFILLED = 'INITIAL_LOADING_FULFILLED';
export const INITIAL_LOADING_ERROR = 'INITIAL_LOADING_ERROR';

// FETCH_APPLICATIONS
export const FETCH_APPLICATIONS_PENDING = 'FETCH_APPLICATIONS_PENDING';
export const FETCH_APPLICATIONS_FULFILLED = 'FETCH_APPLICATIONS_FULFILLED';
export const FETCH_APPLICATIONS_ERROR = 'FETCH_APPLICATIONS_ERROR';

// UPDATE_APPLICATION
export const UPDATE_APPLICATION_PENDING = 'UPDATE_APPLICATION_PENDING';
export const UPDATE_APPLICATION_FULFILLED = 'UPDATE_APPLICATION_FULFILLED';
export const UPDATE_APPLICATION_ERROR = 'UPDATE_APPLICATION_ERROR';
